var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title"},[_c('i',{class:'fas ' + _vm.icon,style:({color: _vm.color})}),_vm._t("header")],2),_c('div',{staticClass:"card-tools"})]),_c('div',{staticClass:"card-body"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }